import { TransferAssetServiceBase } from './transfer-asset.service.base';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { addPageSpecificationParameters, ENVIRONMENT, HateoasMultipleResponseObject, markAsBackgroundServiceCall, PageSpecification } from '@scisys-uim/uim-common';
import { TransferAsset } from 'assets-model';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class TransferAssetService extends TransferAssetServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

  public findAllUnapproved(pageSpec?: PageSpecification): Observable<HateoasMultipleResponseObject<TransferAsset>> {
    var params = new HttpParams();
    if (pageSpec) {
      params = addPageSpecificationParameters(pageSpec, params);
    }
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<TransferAsset>>(this.serviceBaseUrl + (pageSpec ? '/findAllUnapprovedPaged' : '/findAllUnapproved'), {
      params: params
    }));
  }

  public exampleTransferReminderEmailTemplateParameters(backgroundServiceCall: boolean = true): Observable<{
    [key: string]: string
  }> {
    return this.http.get<{ [key: string]: string }>(this.serviceBaseUrl + '/exampleTransferReminderEmailTemplateParameters', {
      headers: backgroundServiceCall ? markAsBackgroundServiceCall() : null
    });
  }

}



